/** Where a mirrored source comes from, as a link: only a public https:// address opens in a browser (F24). */
export interface UpstreamLink {
  readonly href: string;
  /** The address without its scheme and `.git`, as Git hosts show a repository. */
  readonly label: string;
}

export function upstreamLink(remote: string): UpstreamLink | null {
  if (!remote.startsWith("https://")) return null;
  return { href: remote, label: remote.slice("https://".length).replace(/\.git\/?$/, "").replace(/\/$/, "") };
}
